import { useEffect, useState } from "react";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";

const AlternativeContactInfo = ({ employeeId, employee }) => {
  const userPermissions = JSON.parse(
    localStorage.getItem("Permissions") || "[]"
  );
  const [showInfo, setShowInfo] = useState(false);
  const [showAlternativeContactModal, setShowAlternativeContactModal] =
    useState(false);

  useEffect(() => {
    permissionAccouncementList();
  }, []);

  const permissionAccouncementList = () => {
    userPermissions?.forEach((UserPermission) => {
      if (UserPermission.PermissionName === "Alternative.Contact") {
        setShowInfo(true);
      }
    });
  };

  const emailContact = employee[0]?.Contacts?.find(
    (contact) => contact.ContactTypeId === 102
  )?.Contact;

  const phoneContact = employee[0]?.Contacts?.find(
    (contact) => contact.ContactTypeId === 104
  )?.Contact;

  return (
    <>
      {emailContact || phoneContact ? (
        <div className="mb-4">
          <div className="form-head stuck-headers33 mt-4">
            <div className="form-head stuck-header profile-about-me">
              <div className="mb-0">
                <h4 className="text-primary mb-3 sumh4 addprofile-action">
                  Alternative Contact Info
                </h4>
                <div className="languages-wrapper90">
                  {emailContact && (
                    <div className="languages-item">
                      <div className="icon-wrap">
                        <LazyImage src="/images/org-img/profile/phone.png" />
                      </div>
                      <div className="meta">
                        <span className="dark-inverted">Email</span>
                        <a target="_blank" href={`mailto:${emailContact}`}>
                          <span>{emailContact}</span>
                        </a>
                      </div>
                    </div>
                  )}
                  {phoneContact && (
                    <div className="languages-item">
                      <div className="icon-wrap">
                        <LazyImage src="/images/org-img/profile/mail.png" />
                      </div>
                      <div className="meta">
                        <span className="dark-inverted">Contact</span>
                        {employee[0]?.Code}
                        {phoneContact}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="mb-4">
          <div className="form-head stuck-headers33 mt-4">
            <div className="form-head stuck-header profile-about-me">
              <div className="mb-0">
                <h4 className="text-primary mb-3 sumh4 addprofile-action">
                  Alternative Contact Info
                </h4>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AlternativeContactInfo;
